import { sva } from '@flipster/styled-system/css';
import { center, hstack } from '@flipster/styled-system/patterns';

export const inputRecipe = sva({
  className: 'input',
  slots: ['root', 'input', 'prefix', 'suffix'],
  base: {
    input: {
      caretColor: 'content.accent.info',
    },
  },
  defaultVariants: {
    hierarchy: 'normal',
  },
  variants: {
    hierarchy: {
      normal: {
        root: {
          ...hstack.raw({
            textStyle: 'Text/L/Monospace/Regular',
            color: 'content.default.level-5',
            h: 50,
            pr: 16,
            pl: 10,
            rounded: 8,
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'border.default.level-2',
            _focusWithin: {
              borderColor: 'border.default.level-4',
            },
            '&:not(:has(input:disabled, input:read-only:not(:disabled)))': {
              _hover: {
                borderColor: 'border.default.level-4',
              },
            },
            '&:has(input[aria-invalid="true"]):not(:has(input:disabled, input:read-only:not(:disabled)))': {
              borderColor: 'border.state.negative',
              _focusWithin: {
                borderColor: 'border.state.negative',
              },
              _hover: {
                borderColor: 'border.state.negative',
              },
            },
            '&:has(input:disabled)': {
              color: 'content.default.level-1',
              borderColor: 'border.interaction.disabled',
            },
            '&:has(input:read-only:not(:disabled))': {
              color: 'content.default.level-3',
              borderColor: 'border.default.level-1',
              bg: 'background.default.level-1',
            },
          }),
        },
        input: {
          flex: 1,
          h: '100%',
          bg: 'transparent',
          color: 'inherit',
          _placeholder: {
            color: 'content.default.level-1',
          },
        },
        prefix: {
          ...center.raw({
            mr: 8,
          }),
        },
        suffix: {
          ...center.raw({
            ml: 6,
          }),
        },
      },
    },
  },
});
